import api from "../../services/api";

export default {
  actions: {
    requestResetPasswordByLink({ commit }, payload) {
      commit("clearError");
      commit("setLoading", true);

      return new Promise((resolve, reject) => {
        api
          .post("resetpassword/", {
            email: payload.email,
            language: payload.locale
          })
          .then(result => {
            resolve(result.data);
          })
          .catch(err => {
            commit("setError", err.response || err);
            try {
              reject(err.response.data.error);
            } catch (e) {
              reject(err);
            }
          })
          .finally(() => commit("setLoading", false));
      });
    },
    changePasswordByLink({ commit }, payload) {
      commit("clearError");
      commit("setLoading", true);

      return new Promise((resolve, reject) => {
        api
          .post(`resetpassword/${payload.token}`, {
            password: payload.password
          })
          .then(result => {
            resolve(result.data);
          })
          .catch(err => {
            commit("setError", err.response || err);
            try {
              reject(err.response.data.error);
            } catch (e) {
              reject(err);
            }
          })
          .finally(() => commit("setLoading", false));
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/resetPassword/index.js